    import axios from 'axios';
    import { API_CONFIG, isValidApiKey } from '../config';
    import { userRecipePrompt } from '../prompts/recipePrompts';

    // Создаем инстанс axios с предустановленными параметрами
    const openaiApi = axios.create({
    baseURL: API_CONFIG.OPENAI.BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${API_CONFIG.OPENAI.API_KEY}`
    }
    });

    // Добавляем интерцептор для проверки ключа перед каждым запросом
    openaiApi.interceptors.request.use(config => {
    const apiKey = config.headers.Authorization.replace('Bearer ', '');
    
    if (!isValidApiKey(apiKey)) {
        throw new ChatGPTError(
        'Invalid API key configuration',
        'CONFIG_ERROR'
        );
    }
    
    return config;
    });

    export class ChatGPTError extends Error {
    constructor(message, type = 'GENERAL_ERROR') {
        super(message);
        this.type = type;
        this.name = 'ChatGPTError';
    }
    }

    export const analyzeRecipeInput = async (userInput) => {
    try {
        const response = await openaiApi.post('/chat/completions', {
        model: API_CONFIG.OPENAI.MODELS.GPT4,
        messages: [
            {
            role: 'system',
            content: 'You are a helpful assistant designed to output JSON.',
            },
            {
            role: 'user',
            content: userRecipePrompt(userInput),
            },
        ],
        max_tokens: 1000,
        });

        const content = response.data.choices[0].message.content;
        
        try {
        return JSON.parse(content);
        } catch (parseError) {
        console.error('Parse error:', parseError);
        throw new ChatGPTError(
            'Failed to parse ChatGPT response',
            'PARSE_ERROR'
        );
        }
    } catch (error) {
        console.error('API error:', error);
        
        if (error instanceof ChatGPTError) throw error;
        
        if (error.response) {
        // Ошибка от API
        throw new ChatGPTError(
            `API Error: ${error.response.status} - ${error.response.data.error?.message || 'Unknown error'}`,
            'API_ERROR'
        );
        }
        
        if (error.request) {
        // Ошибка сети
        throw new ChatGPTError(
            'Network error - unable to reach OpenAI servers',
            'NETWORK_ERROR'
        );
        }
        
        throw new ChatGPTError(
        'An unexpected error occurred',
        'UNKNOWN_ERROR'
        );
    }
    };

    // Добавляем функцию для проверки работоспособности API
     